/**
 * Formularz pytań na karcie produktu (w sekcji opinie),
 * załadowanie oraz wysłanie formularza
 * @type module
 */
app.service('opinionQuestions',function(modal, loading, validate, front, productCardConfig, captchaService) {
	var $showButton, $hideButton, $showMoreButton, $askButton;

	function showQuestions(id) {
		$('.js-opinion-questions-button[data-id='+ id + ']').addClass('button-hidden');
		$('#opinion-' + id + ' .question-box').removeClass('question-box-hidden');
	}
	function hideQuestions(id) {
		$('.js-opinion-questions-button[data-id='+ id + ']').removeClass('button-hidden');
		$('#opinion-' + id + ' .question-box').addClass('question-box-hidden');
	}
	function showMore(id) {
		$('#opinion-' + id + ' .question-box').removeClass('question-box-limited');
	}
	function getForm(id) {
		$.ajax({
			url:'/opinion-question-form.ltr',
			type:'GET',
			cache:false,
			data: {
				'productOpinion': id
			},
			success: function(html) {
				$('#opinion-question' + id).html(html).addClass('form-visible');
				formComplete(id);
				$.scrollTo('#opinion-' + id);
				$('#question-content' + id).focus();
				
				addOpinionQuestionCaptcha(id);
			}
		});
	}
	function formComplete(id) {
		setValidator(id);
	}
	function addOpinionQuestionCaptcha(id) {
		let $captcha = $('#question-form' + id).find('[data-toggle="captcha"]');
		if ($captcha.length) {
			captchaService.load($captcha.attr('id'), $captcha.data('place'));
		}
	}
	function setValidator(id) {
		validate.task('opinionQuestion', {id:id,submit:submit});
	}
	function hideForm(id) {
		$('#opinion-question' + id).html('').removeClass('form-visible');
	}
	function submit(form) {
		var id = $(form).data('id');
		$(form).ajaxSubmit({
			beforeSubmit:function(){
				loading.start();
			},
			url:'/opinion-question-form.ltr?productOpinion='+id,
			data:{chandelier:parseInt(new Date().getTime()/1456)},
			target:'#question-form' + id,
			success:function(html){
				loading.stop();
				formComplete(id);
				UA.interaction('KP', 'Opinie', 'Zadaj pytanie - Wysłane');
				$('#question-form' + id).find('textarea.hasEditor').wysiwyg();
				addOpinionQuestionCaptcha(id);
			},error:function(){
				loading.stop();
				modal.alert('Wystąpił błąd zapisu pytania. Proszę spróbować później');
			}
		});
	}
	function setEvents(){
		$showButton.on('click',function(){
			showQuestions($(this).data('id'));
			UA.interaction('KP', 'Opinie', 'Pokaż pytania');
		});
		$hideButton.on('click',function(){
			hideQuestions($(this).data('id'));
			UA.interaction('KP', 'Opinie', 'Zwiń pytania');
		});
		$self.on('click', '.js-cancel-question-button', function(){
			hideForm($(this).data('id'));
		});
		$showMoreButton.on('click',function() {
			showMore($(this).data('id'));
			UA.interaction('KP', 'Opinie', 'Pokaż wszystkie pytania');
		});
		$askButton.on('click', function(){
			if(front.katalog){
				window.open(productCardConfig.getData().euroUrl+'#opinie');
			}else{
				getForm($(this).data('id'));
				UA.interaction('KP', 'Opinie', 'Zadaj pytanie');
			}
		});
	}
	function setElements(){
		$showButton = $self.find('.js-opinion-questions-button');
		$hideButton = $self.find('.js-opinion-questions-hide-button');
		$showMoreButton = $self.find('.js-toggle-opinion-questions-button');
		$askButton = $self.find('.js-opinion-ask');
	}
	function init(){
		$self = $('#opinion-list');
		setElements();
		setEvents();
	}
	return {
		init: init
	};
});
